// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--CqKBw","logo":"_1410bfd27b--logo--oRSNw"};